import { Controller } from 'react-hook-form';
import { Stack, Switch, Text } from '@mantine/core';
import type { Control, FieldPathByValue } from 'react-hook-form';
import type { FilterState } from '@/features/filterSlice';

type TreesToggleProps = {
  control: Control<FilterState>;
  fieldName: FieldPathByValue<FilterState, boolean>;
  title: string;
  label: string;
};

export const TreesToggle = ({
  control,
  fieldName,
  title,
  label,
}: TreesToggleProps) => (
  <Stack gap="xs">
    <Text c="var(--os-mainColor-foreground-secondary)">{title}</Text>
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, value } }) => (
        <Switch
          id={fieldName}
          data-testid={`trees-toggle-${fieldName}`}
          label={label}
          checked={value}
          onChange={(e) => onChange(e.currentTarget.checked)}
        />
      )}
    />
  </Stack>
);
